
/**
 * TS won't compile if any variable that is not type 'never' is passed in.
 * Best used in the default clause of a switch on an enum.
 */
export const neverHere = (x: never, reason?: string): never => {
  let message = `Value passed into neverHere: ${JSON.stringify(x)}`;
  if (reason) {
    message += ` (${reason})`;
  }

  throw new Error(message);
};
